export default __webpack_public_path__ + "54de41dbf6ece4e137e7e50f4006d739.svg";